module.exports = __webpack_public_path__ + "img/action1.ce1e1852.jpg";